const ups_image_nodelist = Array.from(
  document.querySelectorAll(".usp--icons__image")
);

let animationGap = 700;
let currentIndex = 0;

function animateImages() {
  let uspImage = ups_image_nodelist[currentIndex];
  uspImage.classList.add("usp-scaling-transition");
  setTimeout(() => {
    uspImage.classList.remove("usp-scaling-transition");
    if (currentIndex === ups_image_nodelist.length - 1) {
      currentIndex = 0;
    } else {
      currentIndex += 1;
    }
    animateImages();
  }, animationGap);
}

animateImages();